export const messages = {
  labels: {
    cancerDiagnosis: {
      id: 'treatmentSummary.Groups.FamilyHistory.CancerDiagnosis',
      defaultMessage: 'Diagnosis: ',
    },
    ageAtDiagnosis: {
      id: 'treatmentSummary.Groups.FamilyHistory.AgeAtDiagnosis',
      defaultMessage: 'Age at Diagnosis: ',
    },
    currentStatus: {
      id: 'treatmentSummary.Groups.FamilyHistory.CurrentStatus',
      defaultMessage: 'Current Status: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.FamilyHistory.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
